module.exports = __webpack_public_path__ + "img/d200904-2.80495c67.jpg";